import TemplateContents from './TemplateContents';

import {gsap} from "gsap";

import BicCarousel from "./BicCarousel";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();

    this.carousel = new BicCarousel();
    this.carousel.setTarget(this.featurePanelDom, this.featurePanelInner);

    // スライド連動用の変数初期化
    this.globalMouse = { x: this.sw / 2, y: this.sh / 2 }; // 画面全体のマウス位置

    // windowに対してのmousemoveイベントハンドラを定義
    this.globalMouseMoveHandler = (e) => {
      this.globalMouse.x = e.clientX;
      this.globalMouse.y = e.clientY;
    };

    this.prevTrackX = 0;
    this.isFirstFrame = true;
    this.itemsState = new Map(); // 各アイテムの座標やDOMを管理

    // CSS transitionをJS制御に切り替える準備
    this.itemAll.forEach(item => {
      const inner = item.querySelector('.item_inner');
      const front = item.querySelector('.front');
      const back = item.querySelector('.back');

      this.itemsState.set(item, {
        mouseX: 0,       // マウスの目標X位置
        mouseY: 0,       // マウスの目標Y位置
        currentMouseX: 0, // 現在のX位置（イージング用）
        currentMouseY: 0, // 現在のY位置（イージング用）
        inner: inner,    // DOMキャッシュ
        front: front,    // DOMキャッシュ
        back: back       // DOMキャッシュ
      });
    });
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
    this.mouseTiltFactor = 0.1;
  }

  setDom() {
    super.setDom();

    this.featurePanelDom = document.querySelector('main.top .feature_panel');
    this.featurePanelInner = document.querySelector('main.top .feature_panel .feature_panel_inner');
    this.closeBtn = document.querySelector('main.top .feature_panel .c_close_btn');
    this.bgDom = document.querySelector('main.top .feature_panel .bg');
    this.itemAll = document.querySelectorAll('main.top .feature_panel ul .item');
    this.track = document.querySelector('main.top .feature_panel ul'); // カルーセルの動く部分
    this.arrow = document.querySelector('main.top .feature_panel .arrow');

    this.prevBtn = document.querySelector('main.top .feature_panel .ui .prev_bt');
    this.nextBtn = document.querySelector('main.top .feature_panel .ui .next_bt');
  }

  initEvents() {
    super.initEvents();

    this.closeBtn.addEventListener('click', ()=>{
      this.close();
    });

    this.pack.applyIconHoverEffect(this.closeBtn, this.closeBtn);
    this.pack.applyIconHoverEffect(this.prevBtn, this.prevBtn);
    this.pack.applyIconHoverEffect(this.nextBtn, this.nextBtn);

    this.prevBtn.addEventListener('mousedown', ()=>{
      this.pack.commonClick(this.prevBtn);
    });

    this.prevBtn.addEventListener('touchstart', ()=>{
      this.pack.commonClick(this.prevBtn);
    });

    this.nextBtn.addEventListener('mousedown', ()=>{
      this.pack.commonClick(this.nextBtn);
    });

    this.nextBtn.addEventListener('touchstart', ()=>{
      this.pack.commonClick(this.nextBtn);
    });

    this.bgDom.addEventListener('click', ()=>{
      this.close();
    });

    this.itemAll.forEach((item) => {
      item.addEventListener('mousemove', (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        // 目標値をセットするだけにして、描画はenterframeで行う
        const state = this.itemsState.get(item);
        if (state) {
          state.mouseX = e.clientX - rect.left - (rect.width / 2);
          state.mouseY = e.clientY - rect.top - (rect.height / 2);
        }
      });

      item.addEventListener('mouseleave', () => {
        const state = this.itemsState.get(item);
        if (state) {
          state.mouseX = 0;
          state.mouseY = 0;
        }
      });

      item.addEventListener('mouseenter', () => {
        if(this.arrow) this.arrow.classList.add('show');
      });
      item.addEventListener('mouseleave', () => {
        if(this.arrow) this.arrow.classList.remove('show');
      });
    });
  }

  start() {}

  open(){
    this.featurePanelDom.classList.add('active');
    requestAnimationFrame(()=>{
      this.featurePanelDom.classList.add('open');
    });

    // iOS Safariでの描画バグ（二重表示など）を防ぐために強制リフローを発生させる
    void this.featurePanelDom.offsetWidth;

    window.addEventListener('mousemove', this.globalMouseMoveHandler);
    this.isFirstFrame = true; // 再オープン時に移動量の計算をリセット
    this.pack.common.lockScroll = true;
    if (this.sw < this.pack.BP) document.documentElement.classList.add('lock');
    this.carousel.resizeHandler();
    this.pack.top.hero.pause();
  }

  close(){
    this.featurePanelDom.classList.remove('open');
    window.removeEventListener('mousemove', this.globalMouseMoveHandler);

    gsap.delayedCall(.5, ()=>{
      this.featurePanelDom.classList.remove('active');
      this.pack.common.lockScroll = false;
      if (this.sw < this.pack.BP) document.documentElement.classList.remove('lock');
    });

    this.pack.top.hero.resume();
  }

  scrollHandler() {}

  enterframe() {
    if(this.pack.hasTouch) return;

    if (!this.track || !this.featurePanelDom.classList.contains('open')) return;

    // 1. カルーセルの移動速度を計算
    const currentTrackX = this.track.getBoundingClientRect().left;
    
    if (this.isFirstFrame) {
      this.prevTrackX = currentTrackX;
      this.isFirstFrame = false;
    }

    const diff = currentTrackX - this.prevTrackX;
    this.prevTrackX = currentTrackX;

    // 更新が必要かどうかのフラグ（カルーセルが動いているか？）
    let shouldUpdate = Math.abs(diff) > 0.01;

    // 2. 各アイテムのイージング計算と更新判定
    this.itemsState.forEach((state) => {
      const diffX = state.mouseX - state.currentMouseX;
      const diffY = state.mouseY - state.currentMouseY;

      // まだ目標値に到達していなければ更新が必要
      if (Math.abs(diffX) > 0.01 || Math.abs(diffY) > 0.01) {
        shouldUpdate = true;
      }

      // イージング処理（現在値 += (目標値 - 現在値) * 減衰率）
      state.currentMouseX += diffX * 0.1;
      state.currentMouseY += diffY * 0.1;
    });

    // 動きがなければDOM操作をスキップ（負荷軽減）
    if (!shouldUpdate) return;

    // 速度に応じた傾き（係数1.5は動きの強さ）
    const slideTilt = diff * 1.5;

    // 3. DOMに適用
    this.itemsState.forEach((state, item) => {
      const x = state.currentMouseX;
      const y = state.currentMouseY;

      // マウス位置に応じてZ軸方向にも動かす（ズームイン・アウト効果）
      // 中心から離れるほど、手前はより手前へ、奥はより奥へ移動させる
      const dist = Math.abs(x) + Math.abs(y);
      // 固定値をなくし、距離に比例してZ軸を動かす
      // 1rem = 10px換算
      // 以前の固定値(14rem)くらいのインパクトが出るように係数を大きく調整
      const moveZ_Front = (dist * 0.8) / 10;
      const moveZ_Back = (dist * 0.3) / 10;

      // カルーセル移動時の傾きを、マウスとの距離に応じて減衰させる
      // アイテムの中心座標を取得
      const rect = item.getBoundingClientRect();
      const itemCenterX = rect.left + rect.width / 2;
      
      // マウスX座標との距離
      const distFromMouse = Math.abs(this.globalMouse.x - itemCenterX);
      
      // 距離に応じた係数（画面幅の60%程度を影響範囲とし、近いほど1、遠いほど0に近づく）
      // 範囲を広げてなだらかにする
      let proximityScale = 1 - (distFromMouse / (this.sw * 0.8));
      // 遠くても完全に止まらず、もう少し動くようにする（最小値0.3）
      if (proximityScale < 0.3) proximityScale = 0.3;

      // 距離係数を適用した傾き量
      const localSlideTilt = slideTilt * proximityScale;

      // マウス位置による回転 + スライド速度による回転(localSlideTilt)を合成
      const rotateX_Front = -y * this.mouseTiltFactor;
      const rotateY_Front = x * this.mouseTiltFactor + localSlideTilt * 0.5;

      const rotateX_Back = -y * this.mouseTiltFactor;
      const rotateY_Back = x * this.mouseTiltFactor + localSlideTilt * 0.4;

      const rotateX_Item = -y * this.mouseTiltFactor;
      const rotateY_Item = x * this.mouseTiltFactor + localSlideTilt * 0.3;

      // DOMに適用
      if(state.front) state.front.style.transform = `translate3d(0, 0, ${moveZ_Front}rem) rotateX(${rotateX_Front}deg) rotateY(${rotateY_Front}deg)`;
      if(state.back) state.back.style.transform = `translate3d(0, 0, -${moveZ_Back}rem) rotateX(${rotateX_Back}deg) rotateY(${rotateY_Back}deg)`;
      if(state.inner) state.inner.style.transform = `rotateX(${rotateX_Item}deg) rotateY(${rotateY_Item}deg)`;
    });

    // 矢印の追従処理
    if (this.arrow && this.arrow.classList.contains('show')) {
      const rect = this.featurePanelInner.getBoundingClientRect();
      const x = this.globalMouse.x - rect.left;
      const y = this.globalMouse.y - rect.top;
      this.arrow.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }
  }

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
